module.exports = __webpack_public_path__ + "img/TBWTTNL_benefits_screentime.476756cf.png";